import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("../views/index.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/guide/:id",
    name: "Guide",
    component: () => import("../views/Guide.vue"),
  },
  {
    path: "/discount",
    name: "Discount",
    component: () => import("../views/discount"),
  },
  {
    path: "/real",
    name: "Real",
    component: () => import("../views/Real"),
  },
  {
    path: "/wechat",
    name: "WeChat",
    component: () => import("../views/WeChat.vue"),
  },
  {
    path: "/wechats",
    name: "WeChats",
    component: () => import("../views/WeChats.vue"),
  },
  {
    path: "/code",
    name: "Code",
    component: () => import("../views/code/index.vue"),
  },
  {
    path: "/problems",
    name: "Problems",
    component: () => import("../views/shopping/problem.vue"),
  },

  {
    path: "/classify",
    name: "Classify",
    component: () => import("../views/shopping/classify.vue"),
  },
  {
    path: "/guide2/:id/:type",
    name: "Guide2",
    component: () => import("../views/Guide2.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/cardform",
    name: "cardform",
    component: () => import("../views/cardform.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin.vue"),
  },
  {
    path: "/recharges",
    name: "Recharges",
    component: () => import("../views/Recharges.vue"),
  },
  {
    path: "/coupon",
    name: "Coupon",
    component: () => import("../views/coupon"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/Privacy.vue"),
  },
  {
    path: "/clause",
    name: "Clause",
    component: () => import("../views/Clause.vue"),
  },
  {
    path: "/kefu",
    name: "KeFu",
    component: () => import("../views/Kefu.vue"),
  },
  {
    path: "/shopping",
    name: "Shopping",
    component: () => import("../views/shopping/index.vue"),
  },
  {
    path: "/orderList",
    name: "orderList",
    component: () => import("../views/shopping/orderList.vue"),
  },
  {
    path: "/shopDetail",
    name: "shopDetail",
    component: () => import("../views/shopping/shopDetail.vue"),
  },
  {
    path: "/buys",
    name: "buys",
    component: () => import("../views/shopping/buys.vue"),
  },
  {
    path: "/course",
    name: "course",
    component: () => import("../views/shopping/course.vue"),
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("../views/Detail.vue"),
  },
  {
    path: "/banlance/:id/:banlance/:ss",
    name: "Banlance",
    component: () => import("../views/Banlance.vue"),
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/Order.vue"),
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/Order.vue"),
  },
  {
    path: "/problem",
    name: "Problem",
    component: () => import("../views/Problem.vue"),
  },
  {
    path: "/livecode/:id",
    name: "Livecode",
    component: () => import("../views/Livecode.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/registers",
    name: "Registers",
    component: () => import("../views/Registers.vue"),
  },
  {
    path: "/password",
    name: "PassWord",
    component: () => import("../views/PassWord.vue"),
  },
  {
    path: "/success",
    name: "Success",
    component: () => import("../views/Success.vue"),
  },
  {
    path: "/query",
    name: "Query",
    component: () => import("../views/Query.vue"),
  },
  {
    path: "/recharge",
    name: "Recharge",
    component: () => import("../views/Recharge.vue"),
  },
  {
    path: "/change",
    name: "Change",
    component: () => import("../views/Change.vue"),
  },
  {
    path: "/switch",
    name: "Switch",
    component: () => import("../views/Switch.vue"),
  },
  {
    path: "/apn",
    name: "Apn",
    component: () => import("../views/APN.vue"),
  },
  {
    path: "/addcard",
    name: "AddCard",
    component: () => import("../views/AddCard.vue"),
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: () => import("../views/Feedback.vue"),
  },
  {
    path: "/detailorders/:id",
    name: "DetailOrder",
    component: () => import("../views/DetailOrder.vue"),
  },
  {
    path: "/address",
    name: "Address",
    component: () => import("../views/Address.vue"),
  },
  {
    path: "/image",
    name: "Image",
    component: () => import("../views/image.vue"),
  },
  {
    path: "/gonggao",
    name: "Gonggao",
    component: () => import("../views/Gonggao.vue"),
  },
  {
    path: "/testing",
    name: "Testing",
    component: () => import("../views/testing"),
  },
  {
    path: "/speed",
    name: "Speed",
    component: () => import("../views/speed"),
  },
  {
    path: "/orders",
    name: "Orders",
    component: () => import("../views/orders.vue"),
  },
  {
    path: "/autoRenew",
    name: "AutoRenew",
    component: () => import("../views/autoRenew.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
